import { addDisplayName, addHandlers, addProps, flowMax } from 'ad-hok'
import React, { ComponentProps, FC } from 'react'
import { createUseStyles } from 'react-jss'

import { textColorLight } from './styles'
import { Field } from './Field'

const useStyles = createUseStyles({
  text: {
    width: 46,
    height: 46,
    border: '1px solid rgba(0, 0, 0, 0.17)',
    color: textColorLight,
    paddingLeft: 19,
    paddingRight: 19,
    fontSize: 14,
  },
})

interface Props extends ComponentProps<typeof Field> {
  value: boolean
  onChange: (value: boolean) => void
}

export const Toggle: FC<Props> = flowMax(
  addDisplayName('Toggle'),
  addHandlers({
    onChange:
      ({ onChange, value }) =>
      () => {
        onChange(!value)
      },
  }),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ id, label, value, onChange, error, classes }) => (
    <Field id={id} label={label} error={error}>
      <input
        name={id}
        id={id}
        type="checkbox"
        onChange={onChange}
        checked={value}
        className={classes.text}
      />
    </Field>
  )
)
